const brands = {
  visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
  mastercard: /^5[1-5][0-9]{14}$/,
  american_express: /^3[47][0-9]{13}$/,
  discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
  elo: /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})$/,
};

/**
 * Return card's name based on it's number
 *
 * @param {number} number The credit card number
 */
function getCardType(number) {
  if (!number) {
    return null;
  }

  number = number.replace(/\s/g, '');

  for (let key in brands) {
    if (brands[key].test(number)) {
      return key;
    }
  }
}

/**
 * Return card's name based on it's number
 *
 * @param {number} number The credit card number
 */
function mapCreditCardData(data) {
  return {
    card: data.card,
    number: data.number
      ? data.number
      : data.numberDlocal
      ? data.numberDlocal + '*********'
      : null,
    backgroundColor: data.backgroundColor,
    imageUrl: data.imageUrl,
    hideInfo: data.hideInfo,
    holderName: data.holderName,
    expiryDate: data.expiryDate,
    cvv: data.cvv,
  };
}

/**
 * Returns a formatted credit card number
 *
 * @param {number} number The credit card number
 * @param {string} type The card brand name
 */
function formatCardNumber(number, type) {
  if (!number) {
    return '';
  }

  number = number.replace(/\s/g, '');

  if (type && type.toLowerCase().replace(/\s/g, '_') === 'american_express') {
    return number.replace(/\b(\d{4})(\d{6})(\d{5})\b/, '$1 $2 $3');
  } else {
    return number.replace(/\W/gi, '').replace(/(.{4})/g, '$1 ');
  }
}

/**
 * Returns a credit card number without spaces
 *
 * @param {number} number The credit card number
 */
function formatCardNumberToSave(number) {
  if (!number) {
    return '';
  }

  return number.replace(/\s/g, '');
}

/**
 * Returns a specific card brand info object
 *
 * @param {string} cardType The card brand name
 * @param {array} brands Array of card brands
 */
function getBrandInfo(cardType, brands) {
  return brands.find(
    brand =>
      brand.name.toLowerCase().replace(/\s/g, '_') === cardType ||
      brand.name.toLowerCase().replace(/\s/g, '-') === cardType
  );
}

/**
 * Replaces CVV string by bullets to hide data
 *
 * @param {string} string Card cvv number
 */
function hideCVV(string) {
  if (!string) {
    return null;
  }

  return string
    .split('')
    .map(() => '•')
    .join('');
}

/**
 * Check if card expiry date is valid
 *
 * @param {string} date The date string
 */
function validateExpiryDate(date) {
  const now = new Date();

  if (!date || date.length < 5) {
    return false;
  }

  let [month, year] = date.split('/');

  year = `20${year}`;

  const fullDate = `${year}-${month}-01`;
  const refererDate = new Date(fullDate);

  return refererDate > now;
}

/**
 * Checks is card number is valid
 *
 * @param {string} number The card number string
 */
function validateCardNumber(number) {
  try {
    const regex = new RegExp('^[0-9]{15,16}$');
    number = number.replace(/\s/g, '');

    if (!regex.test(number)) {
      return false;
    }

    return luhnCheck(number);
  } catch (error) {
    return false;
  }
}

/* luhn_checksum
 * Implement the Luhn algorithm to calculate the Luhn check digit.
 * Return the check digit.
 */
function luhnCheck(code) {
  var len = code.length;
  var parity = len % 2;
  var sum = 0;
  for (var i = len - 1; i >= 0; i--) {
    var d = parseInt(code.charAt(i));
    if (i % 2 == parity) {
      d *= 2;
    }
    if (d > 9) {
      d -= 9;
    }
    sum += d;
  }
  return sum % 10 == 0;
}

/**
 * Format CPF or CNPJ based on realtime user input
 *
 * @param {string} data The CPF or CNPJ to be verified and formatted
 */
function maskCpfCnpj(data) {
  data = data.replace(/(\.|\/|\-)/g, '');

  if (data.length <= 11) {
    data = data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
  } else {
    data = data.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
      '$1.$2.$3/$4-$5'
    );
  }

  return data;
}

/**
 * Returns a credit card number with hidden numbers
 *
 * @param {object} card The object containing all CC data
 */
function createHiddenCardNumber(card) {
  let { firstDigits, lastDigits, cardBrand: brand } = card;
  const brandName = brand.name.toLowerCase().replace(/\s/g, '_');

  if (firstDigits == '' || firstDigits == null) {
    if (card.numberDlocal) firstDigits = card.numberDlocal;
    else firstDigits = 'oooooo';
  }
  const digits =
    brandName === 'american_express' || brandName === 'american-express'
      ? `${firstDigits}ooooo${lastDigits}`
      : `${firstDigits}oooooo${lastDigits}`;

  return formatCardNumber(digits, brand.name).replace(/o/g, '*');
}

/**
 * Validates credit card holder's name
 *
 * @param {string} holderName The holden name
 */
function validateHolderName(holderName) {
  try {
    const nameParts = holderName.split(' ');
    return nameParts.length > 1;
  } catch (error) {
    return false;
    ß;
  }
}

/**
 * Validates CVV number
 *
 * @param {string} cvv The credit card cvv number
 */
function validateCVV(cvv) {
  const pattern = /^[0-9]{3,4}$/;
  return pattern.test(cvv);
}

/**
 * Validates user id
 *
 * @param {srtring} holderDocument User's CPF or CNPJ
 */
function validateHolderDocument(holderDocument) {
  try {
    if (holderDocument.length === 14) {
      let cpf = holderDocument.trim();

      cpf = cpf.replace(/\./g, '');
      cpf = cpf.replace('-', '');
      cpf = cpf.split('');

      let v1 = 0;
      let v2 = 0;
      let aux = false;

      for (let i = 1; cpf.length > i; i++) {
        if (cpf[i - 1] != cpf[i]) {
          aux = true;
        }
      }

      if (aux == false) {
        return false;
      }

      for (let i = 0, p = 10; cpf.length - 2 > i; i++, p--) {
        v1 += cpf[i] * p;
      }

      v1 = (v1 * 10) % 11;

      if (v1 == 10) {
        v1 = 0;
      }

      if (v1 != cpf[9]) {
        return false;
      }

      for (let i = 0, p = 11; cpf.length - 1 > i; i++, p--) {
        v2 += cpf[i] * p;
      }

      v2 = (v2 * 10) % 11;

      if (v2 == 10) {
        v2 = 0;
      }

      if (v2 != cpf[10]) {
        return false;
      } else {
        return true;
      }
    } else if (holderDocument.length === 18) {
      let cnpj = holderDocument.trim();

      cnpj = cnpj.replace(/\./g, '');
      cnpj = cnpj.replace('-', '');
      cnpj = cnpj.replace('/', '');
      cnpj = cnpj.split('');

      let v1 = 0;
      let v2 = 0;
      let aux = false;

      for (let i = 1; cnpj.length > i; i++) {
        if (cnpj[i - 1] != cnpj[i]) {
          aux = true;
        }
      }

      if (aux == false) {
        return false;
      }

      for (let i = 0, p1 = 5, p2 = 13; cnpj.length - 2 > i; i++, p1--, p2--) {
        if (p1 >= 2) {
          v1 += cnpj[i] * p1;
        } else {
          v1 += cnpj[i] * p2;
        }
      }

      v1 = v1 % 11;

      if (v1 < 2) {
        v1 = 0;
      } else {
        v1 = 11 - v1;
      }

      if (v1 != cnpj[12]) {
        return false;
      }

      for (let i = 0, p1 = 6, p2 = 14; cnpj.length - 1 > i; i++, p1--, p2--) {
        if (p1 >= 2) {
          v2 += cnpj[i] * p1;
        } else {
          v2 += cnpj[i] * p2;
        }
      }

      v2 = v2 % 11;

      if (v2 < 2) {
        v2 = 0;
      } else {
        v2 = 11 - v2;
      }

      if (v2 != cnpj[13]) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
}

export {
  mapCreditCardData,
  getCardType,
  formatCardNumber,
  formatCardNumberToSave,
  getBrandInfo,
  hideCVV,
  validateExpiryDate,
  validateCardNumber,
  maskCpfCnpj,
  createHiddenCardNumber,
  validateHolderName,
  validateCVV,
  validateHolderDocument,
};
